(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name flightScreen.controller:FlightScreenCtrl
   *
   * @description
   *
   */
  angular
    .module('flightScreen')
    .controller('FlightScreenCtrl', FlightScreenCtrl);

  function FlightScreenCtrl(flightScreenService, $interval, $timeout) {
    var vm = this;
    vm.ctrlName = 'FlightScreenCtrl';
    vm.model = {
      flightScreenData : null,
      flightScreenResult : [],
      pageSize : 20,
      pageDelay : 20000,
      pageRefresh : 40000
    }

    function loadFlightScreenData(){
      flightScreenService.getFlightScreenData(function (flightData) {
        vm.model.flightScreenResult = flightData;
        displayFirstSetOfRecords();
      },function () {
        console.log('Flight Screen Data Retrieval Error ');
      });
    }

    function displayFirstSetOfRecords() {

      var len = 0;
      var continueToNextPage = false;
      vm.model.flightScreenData = [];

      if(vm.model.flightScreenResult.length > vm.model.pageSize) {
        len = vm.model.pageSize;
        continueToNextPage = true;
      } else {
        len = vm.model.flightScreenResult.length;
      }
      for(var i=0; i<len; i++) {
        vm.model.flightScreenData.push(vm.model.flightScreenResult[i]);
      }

      if(continueToNextPage == true) {
        $timeout(displaySecondSetOfRecords, vm.model.pageDelay);
      }

    }

    function displaySecondSetOfRecords() {

      vm.model.flightScreenData = [];
      for(var i=vm.model.pageSize; i<vm.model.flightScreenResult.length; i++) {
        vm.model.flightScreenData.push(vm.model.flightScreenResult[i]);
      }

      $timeout(displayFirstSetOfRecords, vm.model.pageDelay);
    }


    loadFlightScreenData();

    $interval(function(){
      loadFlightScreenData();
    }, vm.model.pageRefresh);

  }
}());
